module.exports = __webpack_public_path__ + "media/images/placeholder-team-members-c06bbf5c.png";